export default __webpack_public_path__ + "static/media/OpenSans-ExtraBold.8dafb2ac.ttf";